import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAttendeeSquareIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "currentColor",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "M0 0h24v24H0z" }), /* @__PURE__ */ _jsx("path", {
		d: "M15.5 16.5v-1a2 2 0 0 0-2-2h-3a2 2 0 0 0-2 2v1m5.5-7a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z",
		stroke: "black"
	})]
});
export default SvgAttendeeSquareIcon;
